import type { Bordereau, Mouvement } from '@mairistem/comptabilite';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BaseBordereauState from './BaseBordereauState';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';

class BordereauInconnuState extends BaseBordereauState {
  constructor() {
    super();
    this.step = BordereauStateStep.INCONNU;
    this.state = BordereauStateType.INCONNU;
    this.color = '#000';
    this.libelle = 'Inconnu';
  }

  getBordereauActions(_bordereau : Bordereau): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
    return [
    ];
  }

  getMouvementActions(): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
    return [
    ];
  }
}

export default BordereauInconnuState;
